import BaseQuestionApi from "../BaseQuestionApi";

export default abstract class BaseQuestionIdApi extends BaseQuestionApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/${params["questionId"]}`;
	}
}
